import { Type } from "@angular/core";
import { ICommand } from "../../commands/i-command";
import { IApiService } from "../api/i-api-service";
import { ICellComponent } from "../i-cell-component";
import { ICol } from "./i-col";

type FilterPropertiesByReturnType<T, PropertyReturnType> = {
  [Property in keyof T as `${T[Property] extends PropertyReturnType
  ? string & Property
  : never}`]: T[Property];
};

export type FilteredKeys<T, R> = Extract<
  keyof T,
  Extract<keyof FilterPropertiesByReturnType<T, R>, string>
>;

export abstract class Col<T extends object, C extends Type<ICellComponent<T>>>
  implements ICol<T, C>
{
  commands: ICommand<T, IApiService<T>>[] = [];
  removable: boolean;
  visible = true;
  searchable = false;
  sticky = false;
  isQuestionCol?= false;
  sortable = true;
  constructor(
    public component: C,
    public columnDef: FilteredKeys<T, InstanceType<C>["data"]>,
    public header: string | undefined = undefined,
    public minWidth?: string,
    searchable?: boolean,
    removable?: boolean,
    sortable?: boolean
  ) {
    this.removable = true;
    this.searchable = searchable || false;
    if (removable !== undefined) {
      this.removable = removable;
    }
    if (sortable !== undefined) {
      this.sortable = sortable;
    }
  }

  getElementData(el: T): InstanceType<C>["data"] {
    return el[this.columnDef];
  }

}
